import { FC } from 'react'
import { Link } from 'react-router-dom'
import { PrescricaoSituation, formatDateTime } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { StatusDot } from 'app/components'
import { ROTULO_SITUACAO_PRESCRICAO, SncrNumeroUsado, rotuloNumeroSncr } from '../core/_models'

type IProps = {
  numero: SncrNumeroUsado
}

/** Uma prescrição vista pelo número SNCR: usada na lista do bloco e no resultado do localizador. */
export const SncrNumeroUsadoLinha: FC<IProps> = ({ numero }) => {
  const { t } = useT()
  const cancelada = numero.situacao === PrescricaoSituation.Cancelada

  return (
    <>
      <td className='font-monospace text-nowrap'>
        {rotuloNumeroSncr(numero.numeroSncr, numero.tipoReceitaSncr)}
      </td>
      <td className='text-nowrap'>
        {formatDateTime(numero.data ?? undefined, numero.dataFormatada ?? undefined)}
      </td>
      <td>{numero.pacienteNome || '-'}</td>
      <td className='text-nowrap font-monospace'>{numero.atendimentoProtocolo || '-'}</td>
      <td>
        {/* Cancelada mantém o número consumido: aparece para não parecer receita válida em circulação. */}
        <StatusDot
          label={numero.situacao ? ROTULO_SITUACAO_PRESCRICAO[numero.situacao] : undefined}
          tone={cancelada ? 'warning' : 'neutral'}
        />
      </td>
      <td className='text-end'>
        {numero.pacienteId != null && (
          <Link
            to={`/apps/atendimentosMedicos/historicoClinico/${numero.pacienteId}`}
            target='_blank'
            rel='noopener noreferrer'
            className='btn btn-sm btn-light-primary text-nowrap'
            aria-label={t('sncr.numeros.abrir_historico_aria', {
              paciente: numero.pacienteNome || '',
            })}
          >
            <i className='bi bi-box-arrow-up-right me-1' aria-hidden='true' />
            {t('sncr.numeros.abrir_historico')}
          </Link>
        )}
      </td>
    </>
  )
}
